// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: .org-settings-layout / .org-settings-nav* / .org-settings-content were
   the legacy side-nav shell. Removed — the route now uses Configuracion top-tabs.
   MiembrosTab and GeneralTab styles below are still active (imported by Configuracion). */

/* ── Section ── */
.org-settings-section {
  margin-bottom: 36px;
}

.org-settings-section-title {
  font-family: var(--display);
  font-weight: 400;
  font-size: var(--fs-figure);
  margin: 0 0 4px;
  letter-spacing: -0.005em;
  color: var(--text);
}

.org-settings-section-sub {
  font-size: var(--fs-2xs);
  color: var(--text-muted);
  margin: 0 0 18px;
}

/* Field grid / field display: use the shared .field-grid / .field-display
   primitives (ui/Form/Form.css). The org-prefixed copies were unused. */

/* ── Panel with head (Miembros tab) ── */
.org-panel-with-head {
  border: 1px solid var(--border);
  background: var(--bg-alt);
  border-radius: var(--r-data);
  overflow: hidden;
  margin-bottom: 24px;
}

/* The 6-column members table keeps its columns and scrolls horizontally on
   narrow content widths rather than crushing the columns or overflowing the
   settings layout. Mirrors the Facturación movimientos panel. */
.org-panel-scroll {
  overflow-x: auto;
}

.org-panel-with-head .org-simple-table {
  min-width: 640px;
}

.org-panel-head {
  padding: 14px 18px;
  display: flex;
  align-items: baseline;
  gap: 10px;
  border-bottom: 1px solid var(--border);
}

.org-panel-head h3 {
  margin: 0;
  font-family: var(--display);
  font-weight: 400;
  font-size: var(--fs-prose);
  color: var(--text);
}

.org-panel-count {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-muted);
  font-family: var(--mono);
  font-size: var(--fs-sm);
  padding: 1px 8px;
  border-radius: var(--radius-0);
}

.org-cta {
  margin-left: auto;
  height: 30px;
  padding: 0 14px;
  background: var(--ink-dark);
  color: var(--cream);
  border: 1px solid var(--ink-dark);
  font-family: var(--sans);
  font-size: var(--fs-2xs);
  font-weight: 500;
  letter-spacing: -0.002em;
  border-radius: var(--radius-0);
  cursor: pointer;
  transition:
    background 120ms ease,
    border-color 120ms ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  box-shadow:
    0 1px 0 rgba(0, 0, 0, 0.3),
    inset 0 0 0 1px rgba(242, 227, 181, 0.16);
}

.org-cta:hover {
  background: #060e22;
  border-color: #060e22;
}
.org-cta--disabled,
.org-cta--disabled:hover {
  background: var(--border);
  border-color: var(--border);
  color: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.6;
}

/* ── Simple table ── */
.org-simple-table {
  width: 100%;
  border-collapse: collapse;
}

.org-simple-table thead th {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-muted);
  padding: 10px 12px 10px 0;
  text-align: left;
  border-bottom: 1px solid var(--border);
  background: var(--bg-alt);
}

.org-simple-table thead th:first-child {
  padding-left: 18px;
}
.org-simple-table thead th:last-child {
  padding-right: 18px;
  text-align: right;
}

.org-simple-table tbody tr {
  border-bottom: 1px solid var(--border-soft);
  transition: background 80ms ease;
}

.org-simple-table tbody tr:hover {
  background: var(--bg);
}

.org-simple-table tbody td {
  padding: 12px 12px 12px 0;
  font-size: var(--fs-2xs);
  color: var(--text);
}

.org-simple-table tbody td:first-child {
  padding-left: 18px;
}
.org-simple-table tbody td:last-child {
  padding-right: 18px;
  text-align: right;
}

/* "Ver" and, on the member's own row, "Salir" sit side by side. */
.org-row-actions {
  display: inline-flex;
  gap: 6px;
  white-space: nowrap;
}

.org-cell-mono {
  font-family: var(--mono);
  font-size: var(--fs-xs);
}

.org-cell-muted {
  color: var(--text-muted);
}

/* ── Role badge — outlined square ── */
.org-role-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius-0);
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  color: var(--text-secondary);
  letter-spacing: 0.05em;
}

.org-role-badge.owner {
  background: var(--cream-soft);
  color: var(--cream-deep);
  border-color: var(--cream-deep);
}

/* ── Status dot pill ── */
.org-status-dot-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-xs);
  font-family: var(--mono);
  color: var(--text-secondary);
}

.org-status-dot-pill__d {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--text-muted);
  flex-shrink: 0;
}

.org-status-dot-pill.active .org-status-dot-pill__d {
  background: var(--ok);
}
.org-status-dot-pill.pending .org-status-dot-pill__d {
  background: var(--warn);
}

/* Row-action buttons use the shared .row-action atom (styles/atoms.css). */
`, "",{"version":3,"sources":["webpack://./src/pages/configuracion/Organizacion.css"],"names":[],"mappings":"AAAA;;0FAE0F;;AAE1F,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;wEACwE;;AAExE,yCAAyC;AACzC;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;gEAEgE;AAChE;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,iCAAiC;EACjC,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;EAC9B,eAAe;EACf;;2BAEyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR;;6CAE2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,kEAAkE;AAClE;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;;AAEA,2EAA2E","sourcesContent":["/* NOTE: .org-settings-layout / .org-settings-nav* / .org-settings-content were\n   the legacy side-nav shell. Removed — the route now uses Configuracion top-tabs.\n   MiembrosTab and GeneralTab styles below are still active (imported by Configuracion). */\n\n/* ── Section ── */\n.org-settings-section {\n  margin-bottom: 36px;\n}\n\n.org-settings-section-title {\n  font-family: var(--display);\n  font-weight: 400;\n  font-size: var(--fs-figure);\n  margin: 0 0 4px;\n  letter-spacing: -0.005em;\n  color: var(--text);\n}\n\n.org-settings-section-sub {\n  font-size: var(--fs-2xs);\n  color: var(--text-muted);\n  margin: 0 0 18px;\n}\n\n/* Field grid / field display: use the shared .field-grid / .field-display\n   primitives (ui/Form/Form.css). The org-prefixed copies were unused. */\n\n/* ── Panel with head (Miembros tab) ── */\n.org-panel-with-head {\n  border: 1px solid var(--border);\n  background: var(--bg-alt);\n  border-radius: var(--r-data);\n  overflow: hidden;\n  margin-bottom: 24px;\n}\n\n/* The 6-column members table keeps its columns and scrolls horizontally on\n   narrow content widths rather than crushing the columns or overflowing the\n   settings layout. Mirrors the Facturación movimientos panel. */\n.org-panel-scroll {\n  overflow-x: auto;\n}\n\n.org-panel-with-head .org-simple-table {\n  min-width: 640px;\n}\n\n.org-panel-head {\n  padding: 14px 18px;\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  border-bottom: 1px solid var(--border);\n}\n\n.org-panel-head h3 {\n  margin: 0;\n  font-family: var(--display);\n  font-weight: 400;\n  font-size: var(--fs-prose);\n  color: var(--text);\n}\n\n.org-panel-count {\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--text-muted);\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  padding: 1px 8px;\n  border-radius: var(--radius-0);\n}\n\n.org-cta {\n  margin-left: auto;\n  height: 30px;\n  padding: 0 14px;\n  background: var(--ink-dark);\n  color: var(--cream);\n  border: 1px solid var(--ink-dark);\n  font-family: var(--sans);\n  font-size: var(--fs-2xs);\n  font-weight: 500;\n  letter-spacing: -0.002em;\n  border-radius: var(--radius-0);\n  cursor: pointer;\n  transition:\n    background 120ms ease,\n    border-color 120ms ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  box-shadow:\n    0 1px 0 rgba(0, 0, 0, 0.3),\n    inset 0 0 0 1px rgba(242, 227, 181, 0.16);\n}\n\n.org-cta:hover {\n  background: #060e22;\n  border-color: #060e22;\n}\n.org-cta--disabled,\n.org-cta--disabled:hover {\n  background: var(--border);\n  border-color: var(--border);\n  color: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* ── Simple table ── */\n.org-simple-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.org-simple-table thead th {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n  padding: 10px 12px 10px 0;\n  text-align: left;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-alt);\n}\n\n.org-simple-table thead th:first-child {\n  padding-left: 18px;\n}\n.org-simple-table thead th:last-child {\n  padding-right: 18px;\n  text-align: right;\n}\n\n.org-simple-table tbody tr {\n  border-bottom: 1px solid var(--border-soft);\n  transition: background 80ms ease;\n}\n\n.org-simple-table tbody tr:hover {\n  background: var(--bg);\n}\n\n.org-simple-table tbody td {\n  padding: 12px 12px 12px 0;\n  font-size: var(--fs-2xs);\n  color: var(--text);\n}\n\n.org-simple-table tbody td:first-child {\n  padding-left: 18px;\n}\n.org-simple-table tbody td:last-child {\n  padding-right: 18px;\n  text-align: right;\n}\n\n/* \"Ver\" and, on the member's own row, \"Salir\" sit side by side. */\n.org-row-actions {\n  display: inline-flex;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.org-cell-mono {\n  font-family: var(--mono);\n  font-size: var(--fs-xs);\n}\n\n.org-cell-muted {\n  color: var(--text-muted);\n}\n\n/* ── Role badge — outlined square ── */\n.org-role-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-0);\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  color: var(--text-secondary);\n  letter-spacing: 0.05em;\n}\n\n.org-role-badge.owner {\n  background: var(--cream-soft);\n  color: var(--cream-deep);\n  border-color: var(--cream-deep);\n}\n\n/* ── Status dot pill ── */\n.org-status-dot-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--fs-xs);\n  font-family: var(--mono);\n  color: var(--text-secondary);\n}\n\n.org-status-dot-pill__d {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--text-muted);\n  flex-shrink: 0;\n}\n\n.org-status-dot-pill.active .org-status-dot-pill__d {\n  background: var(--ok);\n}\n.org-status-dot-pill.pending .org-status-dot-pill__d {\n  background: var(--warn);\n}\n\n/* Row-action buttons use the shared .row-action atom (styles/atoms.css). */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
